import { createSelector } from 'reselect';

import { getBuilder } from './getBuilder';

export const getPlacementMode = createSelector(
  getBuilder,
  builder => builder.placementMode
);
